import * as React from 'react'
import { Grid } from 'semantic-ui-react'

import Constants from '../../utils/constants'
import withSkippable from '../../enhancers/skippable'
import { CommentItemToggleableHook } from '../../enhancers/toggleable'
import { TextField } from '../formfields'

class TextQuestionBody extends React.PureComponent {
  static defaultProps = {
    items: [],
    options: {},
  }

  render() {
    let texts = this.props.items.map(r => {
      return (
        <Grid.Row key={r.key} className="resurvey question body">
          <TextField
            name={r.key}
            key={`item-${r.jsonref}`}
            questionName={this.props.name}
            questionWidth={this.props.options.width || Constants.FULLWIDTH}
            label={r.value}
            parentDisabled={this.props.disabled}
            hasComment={r.has_comment}
            jsonref={r.jsonref}
            maxlength={this.props.options.maxlength || Constants.DEFAULTS.TEXT_MAX_LENGTH}
            currentPageName={this.props.currentPageName}
            questionSkipped={this.props.questionSkipped}
          />
          {r.has_comment && (
            <CommentItemToggleableHook
              currentPageName={this.props.currentPageName}
              questionName={this.props.name}
              name={r.key + '_comment'}
              jsonref={r.jsonref + '_comment'}
            />
          )}
        </Grid.Row>
      )
    })

    if (this.props.reverseItems) texts.reverse()
    return texts
  }
}

export default withSkippable(TextQuestionBody)
